import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
import { PDP_REDESIGN_SELECTOR } from '../../utils/constants';
// Official Trustpilot star rating colors
// https://support.trustpilot.com/hc/en-us/articles/201748946
export const TRUSTPILOT_STAR_COLORS = {
    bad: '#FF3722', // 1 star  – Bad/Terrible
    poor: '#FF8622', // 2 stars – Poor
    average: '#FFCE00', // 3 stars – Average
    great: '#73CF11', // 4 stars – Great
    excellent: '#00B67A', // 5 stars – Excellent
};
export const TRUSTPILOT_EMPTY_STAR_COLOR = '#DCDCE6';
const useStyles = makeStyles()((theme) => ({
    wrapper: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: spacing.xs,
        marginBottom: spacing.xs,
        [theme.breakpoints.up('md')]: {
            marginBottom: spacing.small,
        },
        [`${PDP_REDESIGN_SELECTOR} &`]: {
            marginBottom: 0,
        },
    },
    starsContainer: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '2px',
        flexShrink: 0,
        [`${PDP_REDESIGN_SELECTOR} &`]: {
            [theme.breakpoints.up('md')]: {
                padding: `${spacing.xxs} 0`,
            },
        },
        '& svg': {
            [`${PDP_REDESIGN_SELECTOR} &`]: {
                width: spacing.small,
                height: spacing.small,
                [theme.breakpoints.up('md')]: {
                    width: '20px',
                    height: '20px',
                },
            },
        },
    },
    count: Object.assign(Object.assign({}, theme.typography.small_regular), { color: colors.background.BLACK, whiteSpace: 'nowrap', lineHeight: spacing.small, [`${PDP_REDESIGN_SELECTOR} &`]: {
            [theme.breakpoints.up('md')]: {
                lineHeight: '28px',
            },
        } }),
    countValue: {
        textDecorationLine: 'underline',
        textDecorationStyle: 'solid',
    },
    starContentWrapper: {
        marginBottom: spacing.xs,
    },
}));
export default useStyles;
